import {
  Box,
  Card,
  List,
  ListItem,
  makeStyles,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  withStyles
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { Pagination } from '@material-ui/lab';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useSelector } from 'react-redux';
import DialogConfirm from 'src/app/components/DialogConfirm';
import { MESSAGE } from 'src/app/constant/message';
import { PAGE_SIZE_LIST } from 'src/app/constant/config';
import { deleteDriverAccount } from 'src/features/driverSlice';
import { closeDialogConfirm, showDialogConfirm } from 'src/features/uiSlice';

import moment from 'moment';
import { useDispatch } from 'react-redux';
import CreateDriverAccountModal from './CreateDriverAccountModal';
import DriverVehiclesCell from './DriverVehiclesCell';
import EditDriver from './EditDriver';
import ShareDeviceModal from './ShareDeviceModal';
import UpdatePasswordModal from './UpdatePasswordModal';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    whiteSpace: 'nowrap',
    padding: '14px 12px'
  },
  body: {
    fontSize: 14,
    whiteSpace: 'nowrap',
    padding: '16px 12px'
  },
  root: {
    padding: '16px 12px'
  }
}))(TableCell);

const Results = ({
  className,
  listDriverAccounts,
  getListDriverAccountsRef,
}) => {
  const dispatch = useDispatch();
  const totalDriverAccount = useSelector(state => state.driverSlice.totalDriverAccount);
  const classes = useStyles();
  const [limit] = useState(PAGE_SIZE_LIST);
  const [selectedItem, setSelectedItem] = useState();
  const [itemCurrent, setItemCurrent] = useState();

  const [page, setPage] = useState(1);
  const [params, setParams] = useState({
    page: page,
    page_size: limit
  });

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openCreateAccountModal, setOpenCreateAccountModal] = useState(false);
  const [openUpdatePasswordModal, setOpenUpdatePasswordModal] = useState(false);
  const [openShareDeviceModal, setOpenShareDeviceModal] = useState(false);
  const handleClickMenu = (event, driver) => {
    setAnchorEl(event.currentTarget);
    setItemCurrent(driver);
    setSelectedItem(driver.user.id);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  const handleDeleteDriver = () => {
    dispatch(showDialogConfirm());

    handleCloseMenu();
  };
  
  const closeModalEdit = () => {
    setOpenEditModal(false);
  };

  const closeCreateAccountModal = () => {
    setOpenCreateAccountModal(false);
  };

  const closeUpdatePasswordModal = () => {
    setOpenUpdatePasswordModal(false);
  };

  const handleChangePassword = () => {
    setOpenUpdatePasswordModal(true);
    handleCloseMenu();
  };

  const closeShareDeviceModal = () => {
    setOpenShareDeviceModal(false);
  };

  const handleOpenShareDeviceModal = () => {
    setOpenShareDeviceModal(true);
    handleCloseMenu();
  };

  const confirmDelete = async () => {
    if (!selectedItem) return;

    await dispatch(deleteDriverAccount({ id: String(selectedItem) }));
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    if (!getListDriverAccountsRef) return;
    const newparams = Object.assign({}, params, { page: newPage });
    setParams(newparams);
    getListDriverAccountsRef(newparams);
  };

  return (
    <>
      {openCreateAccountModal && (
        <CreateDriverAccountModal
        open={openCreateAccountModal}
          onClose={closeCreateAccountModal}
          driverSelected={itemCurrent}
          onSuccess={() => {
            if (getListDriverAccountsRef) {
              getListDriverAccountsRef(params);
            }
          }}
        />
      )}
      {openEditModal && (
        <EditDriver
          open={openEditModal}
          driverSelected={itemCurrent}
          onClose={closeModalEdit}
        />
      )}
      {openUpdatePasswordModal && (
        <UpdatePasswordModal
          open={openUpdatePasswordModal}
          driverSelected={itemCurrent}
          onClose={closeUpdatePasswordModal}
          onSuccess={() => {
            if (getListDriverAccountsRef) {
              getListDriverAccountsRef(params);
            }
          }}
        />
      )}
      {openShareDeviceModal && (
        <ShareDeviceModal
          open={openShareDeviceModal}
          driverSelected={itemCurrent}
          onClose={closeShareDeviceModal}
          onSuccess={() => {
            if (getListDriverAccountsRef) {
              getListDriverAccountsRef(params);
            }
          }}
        />
      )}
      <DialogConfirm
        textOk={MESSAGE.BTN_YES}
        textCancel={MESSAGE.BTN_CANCEL}
        title="Xác nhận xóa tài khoản lái xe"
        content="Bạn có chắc chắn muốn xóa tài khoản lái xe này không?"
        callbackOk={() => confirmDelete()}
        callbackCancel={() => dispatch(closeDialogConfirm())}
      />

      <Card className={clsx(classes.root, className)}>
          <div>
            <PerfectScrollbar>
              {listDriverAccounts && listDriverAccounts.length ? (
                <Box minWidth={1050}>
                  <Table>
                    {listDriverAccounts?.length > 0 && (
                      <TableHead>
                        <TableRow>
                          <StyledTableCell>Tên đăng nhập</StyledTableCell>
                          <StyledTableCell>Tên tài xế </StyledTableCell>
                          <StyledTableCell>Số điện thoại</StyledTableCell>
                          <StyledTableCell>Phương tiện</StyledTableCell>
                          <StyledTableCell>Địa chỉ</StyledTableCell>
                          <StyledTableCell>Ngày tạo</StyledTableCell>
                          <StyledTableCell></StyledTableCell>
                        </TableRow>
                      </TableHead>
                    )}
                    <TableBody>
                      {(listDriverAccounts || []).map((driver, index) => {
                        if (!driver) return null;
                        return (
                          <TableRow hover key={driver.id}>
                            <StyledTableCell>
                              {driver.user.username || '--'}
                            </StyledTableCell>
                            <StyledTableCell>
                              {driver.user.full_name || '--'}
                            </StyledTableCell>
                            <StyledTableCell>
                              {driver.user.phone || '--'}
                            </StyledTableCell>
                            <StyledTableCell>
                              <DriverVehiclesCell
                                devices={driver.devices}
                                driverName={driver.user.full_name || driver.user.username}
                              />
                            </StyledTableCell>
                            <StyledTableCell>
                              {driver.user.address || '--'}
                            </StyledTableCell>
                            <StyledTableCell>
                              {driver.user.created_at
                                ? moment(driver.user.created_at).format(
                                    'DD-MM-yyyy'
                                  )
                                : '--'}
                            </StyledTableCell>
                            <StyledTableCell>
                              <span style={{ color: '#AEB1C5' }}>
                                <MoreVertIcon
                                  aria-describedby={`menu-device-${driver.id}`}
                                  className="cursor-pointer hover-red"
                                  onClick={e => handleClickMenu(e, driver)}
                                />
                              </span>

                              <Popover
                                id={`menu-device-${driver.id}`}
                                className="popover-device"
                                open={open}
                                anchorEl={anchorEl}
                                onClose={handleCloseMenu}
                                anchorOrigin={{
                                  vertical: 'bottom',
                                  horizontal: 'left'
                                }}
                                transformOrigin={{
                                  vertical: 'top',
                                  horizontal: 'right'
                                }}
                              >
                                <Typography>
                                  <List>
                                    <ListItem
                                      onClick={handleOpenShareDeviceModal}
                                      className="border-bottom list-menu-device cursor-pointer"
                                    >
                                      Chia sẻ thiết bị giám sát
                                    </ListItem>
                                    <ListItem
                                      onClick={handleChangePassword}
                                      className="border-bottom list-menu-device cursor-pointer"
                                    >
                                      Thay đổi mật khẩu
                                    </ListItem>
                                    <ListItem
                                      onClick={handleDeleteDriver}
                                      className="cursor-pointer list-menu-device"
                                    >
                                      <span className="text-danger">Xóa</span>
                                    </ListItem>
                                  </List>
                                </Typography>
                              </Popover>
                            </StyledTableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </Box>
              ) : (
                <div className="text-center pb-5">
                  <img src="/static/empty.png" class="justify-content-center" />
                  <h4> Danh sách trống </h4>
                </div>
              )}
            </PerfectScrollbar>
          </div>
      </Card>
      {listDriverAccounts && listDriverAccounts.length > 0 && (
        <div class="mt-3 mr-4 float-right">
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '15px'
            }}
          >
            <Typography style={{ fontSize: '14px' }}>
              Tổng: {totalDriverAccount}
            </Typography>
            <Pagination
              count={Math.ceil(totalDriverAccount / limit)}
              color="primary"
              size="small"
              onChange={handlePageChange}
              page={Number(params.page)}
              showFirstButton
              showLastButton
            />
          </Box>
        </div>
      )}
    </>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  listDriverAccounts: PropTypes.array.isRequired
};

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    '&.MuiPaper-elevation1': {
      boxShadow: 'none'
    }
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  groupAction: {
    display: 'flex',
    alignItems: 'center',
    '& .action': {
      cursor: 'pointer',
      padding: '0 5px',
      '&:hover': {
        color: '#3f51b5'
      }
    }
  },
  minWithColumn: {
    minWidth: '150px'
  }
}));

export default Results;
